"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEvent = void 0;
var primeTrackEvent = require("./prime/track-event");
var platform_analytics_store_1 = require("./prime/platform-analytics-store");
function trackEvent(namespace, rfrr, linkName, omnitureData, events, trackImmediate, logger, uisPrimeMessages) {
    primeTrackEvent.trackEvent(namespace, rfrr, linkName, uisPrimeMessages, events, trackImmediate, logger, platform_analytics_store_1.PlatformAnalyticsStore.getPlatformAnalytics());
}
exports.trackEvent = trackEvent;
//# sourceMappingURL=track-event.js.map